import { render, staticRenderFns } from "./buyTicketList.vue?vue&type=template&id=2709754a"
import script from "./buyTicketList.vue?vue&type=script&lang=js"
export * from "./buyTicketList.vue?vue&type=script&lang=js"
import style0 from "./buyTicketList.vue?vue&type=style&index=0&id=2709754a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports